import { ReactComponent as Icon } from "../files/document.svg";

import ISVGIconProps from "../ISVGIconProps";

const FilledStar = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default FilledStar;
